import { useState } from "react";

const styles = {
    input:{
        borderRadius: "5px ",
        padding: "5px",
        margin: "5px",
        border: "none",
        background: "#f8fafc",
        width: "100%",
    }
}

const useDatePicker = () => {
    const [startTime, setStartTime] = useState("2021-01-01");
    const TimeComponent =(
        <input
            type="date"
            id="start"
            name="trip-start"
            value={startTime}
            onChange={
                (e) => setStartTime(e.target.value)
            }
            style={styles.input}
       />
    )
    return {
        get: startTime,
        date: TimeComponent,
        set: setStartTime
    }
}
export default  useDatePicker;